import { GetAllSupportTasksInDto, GetAllSupportTasksOutDto } from '../../../types/support-tasks.dto'

export const GET_ALL_SUPPORT_TASKS = 'GET_ALL_SUPPORT_TASKS'
export const GET_ALL_SUPPORT_TASKS_SUCCESS = 'GET_ALL_SUPPORT_TASKS_SUCCESS'
export const GET_ALL_SUPPORT_TASKS_ERROR = 'GET_ALL_SUPPORT_TASKS_ERROR'
export const RESET_GET_ALL_SUPPORT_TASKS = 'RESET_GET_ALL_SUPPORT_TASKS'
export const UPDATE_SUPPORTGET_ALL_SUPPORT_TASKS = 'UPDATE_SUPPORTGET_ALL_SUPPORT_TASKS'

export interface GetAllSupportTasks {
  type: typeof GET_ALL_SUPPORT_TASKS
  payload: GetAllSupportTasksOutDto
}

export interface GetAllSupportTasksSuccess {
  type: typeof GET_ALL_SUPPORT_TASKS_SUCCESS
  payload: GetAllSupportTasksInDto
}

export interface GetAllSupportTasksError {
  type: typeof GET_ALL_SUPPORT_TASKS_ERROR
  payload: string | boolean
}

export interface ResetGetAllSupportTasks {
  type: typeof RESET_GET_ALL_SUPPORT_TASKS
  payload: null
}

export interface UpdateInvitations {
  type: typeof UPDATE_SUPPORTGET_ALL_SUPPORT_TASKS
  payload: GetAllSupportTasksInDto
}

export interface State {
  data: GetAllSupportTasksInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions =
  | GetAllSupportTasks
  | GetAllSupportTasksSuccess
  | GetAllSupportTasksError
  | ResetGetAllSupportTasks
  | UpdateInvitations
